const text2DataUrl = (text) => {
  const canvas = document.createElement('canvas')
  canvas.width = 200
  canvas.height =  100
  canvas.style.display = 'none'
  const context: any = canvas.getContext('2d')
  context.rotate((-15 * Math.PI) / 180)
  context.font = '14px Helvetica Neue'
  context.fillStyle = 'rgba(70, 70, 70, 0.1)'
  context.textAlign = 'left'
  context.textBaseline = 'Middle'
  context.fillText(text, canvas.width / 4, canvas.height / 2)

  return canvas.toDataURL('image/png')
}

const cachedFunc = (func) => {
  let cachedResult = {};
  return (...args) => {
    let cachedKey = JSON.stringify(args);
    if (Object.keys(cachedResult).includes(cachedKey)) {
      return cachedResult[cachedKey];
    } else {
      let ret = func(...args);
      cachedResult[cachedKey] = ret;
      return ret;
    }
  }
}

const cachedText2DataUrl = cachedFunc(text2DataUrl);

export const addWatermark = (element, text) => {
  for (let i = 0; i < element.length; i++) {
    let dataUrl = cachedText2DataUrl(text);
    element[i].style.backgroundImage = `url(${dataUrl})`
  }
}